import React, { useRef, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "../../style/AddEventModal.css";

const EditJobModal = ({ isOpen, jobData, onClose, onSave }) => {
  if (!isOpen) return null;

  // Use refs instead of useState
  const titleRef = useRef();
  const dateRef = useRef();
  const timeRef = useRef();
  const jobPositionRef = useRef();
  const locationRef = useRef();
  const descriptionRef = useRef();
  const linkRef = useRef();

  // Fill the form with existing data when jobData changes
  useEffect(() => {
    if (jobData && isOpen) {
      console.log("Initial job data:", jobData); // Debug log

      // Format the date from various formats to YYYY-MM-DD for the date input
      let formattedDate = jobData.job_date || jobData.event_date;

      if (formattedDate) {
        // Handle different date formats
        if (formattedDate.includes("/")) {
          // Handle DD/MM/YYYY format
          const parts = formattedDate.split("/");
          if (parts.length === 3) {
            // Assuming DD/MM/YYYY format
            formattedDate = `${parts[2]}-${parts[1].padStart(
              2,
              "0"
            )}-${parts[0].padStart(2, "0")}`;
          }
        } else if (formattedDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
          // Already in YYYY-MM-DD format, keep as is
          formattedDate = formattedDate;
        }
      }

      console.log("Formatted date for form:", formattedDate);

      // Set values to form inputs
      if (titleRef.current) titleRef.current.value = jobData.title || "";
      if (dateRef.current) dateRef.current.value = formattedDate || "";
      if (timeRef.current)
        timeRef.current.value = jobData.job_time || jobData.event_time || "";
      if (jobPositionRef.current)
        jobPositionRef.current.value = jobData.job_position || "";
      if (locationRef.current)
        locationRef.current.value = jobData.location || "";
      if (descriptionRef.current)
        descriptionRef.current.value = jobData.description || "";
      if (linkRef.current) linkRef.current.value = jobData.link || "";
    }
  }, [jobData, isOpen]);

  const handleSubmitlink = (event) => {
    event.preventDefault();
    // Not needed for edit mode, but keeping for consistency
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload

    const title = titleRef.current.value.trim();
    const event_date = dateRef.current.value; // Changed from job_date to event_date
    const event_time = timeRef.current.value; // Changed from job_time to event_time
    const job_position = jobPositionRef.current.value.trim();
    const location = locationRef.current.value.trim();
    const description = descriptionRef.current.value.trim();
    const link = linkRef.current.value.trim();

    // Validate job link is not empty
    if (!link) {
      alert("Job link cannot be empty.");
      return;
    }

    // Validate title length before submitting
    if (title.length < 3 || title.length > 255) {
      alert("Title must be between 3 and 255 characters.");
      return;
    }

    // Add console logs for debugging
    console.log("Submitting with date:", event_date);
    console.log("Submitting with time:", event_time);

    // Pass updated job data to parent component
    onSave({
      id: jobData.id, // Preserve the original ID
      title,
      event_date, // Changed property name
      event_time, // Changed property name
      job_position,
      location,
      description,
      link,
    });

    onClose(); // Close modal after submission
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Edit Job Details</h2>
          <CloseIcon className="close-icon" onClick={onClose} />
        </div>

        <input
          type="url"
          ref={linkRef}
          onChange={handleSubmitlink}
          placeholder="Job link: https://example.com"
          className="modal-input"
          required
        />

        <form onSubmit={handleSubmit} className="modal-form">
          <input
            type="text"
            ref={titleRef}
            placeholder="Company Name"
            className="modal-input"
            required
          />

          <input
            type="text"
            ref={jobPositionRef}
            placeholder="Position"
            className="modal-input"
            required
          />

          <div className="modal-date-time">
            <input type="date" ref={dateRef} className="modal-input" />
            <input type="time" ref={timeRef} className="modal-input" />
          </div>

          <input
            type="text"
            ref={locationRef}
            placeholder="Location"
            className="modal-input"
          />

          <textarea
            ref={descriptionRef}
            placeholder="Job Description"
            className="modal-textarea"
          ></textarea>

          <div className="modal-footer">
            <button type="button" className="cancel-button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="save-button">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditJobModal;
